import { Inject, Injectable } from '@angular/core';
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from '../services';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {

    //#region Constructor

    constructor(private _router: Router, @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface) {
    }

    //#endregion

    //#region Methods

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this._userAuthInterface.authenticatedUser;
        if (user && user.token) {
            // logged in so return true
            return true;
        }
        this._router.navigate(["/account/login"]);
        return false;
    }

    //#endregion
}
